import { render, staticRenderFns } from "./PatLgDetail.vue?vue&type=template&id=3f9b2351&scoped=true"
import script from "./PatLgDetail.vue?vue&type=script&lang=js"
export * from "./PatLgDetail.vue?vue&type=script&lang=js"
import style0 from "./PatLgDetail.vue?vue&type=style&index=0&id=3f9b2351&prod&lang=scss&scoped=true"
import style1 from "./PatLgDetail.vue?vue&type=style&index=1&id=3f9b2351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b2351",
  null
  
)

export default component.exports